var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [
      _vm._v(
        _vm._s(_vm.$_.get(_vm.activity, "actorUser.name")) +
          ' kullanıcısı görev başlığını "' +
          _vm._s(_vm.$_.get(_vm.activity, "payload.oldTitle")) +
          '" den "' +
          _vm._s(_vm.$_.get(_vm.activity, "payload.newTitle")) +
          '" olarak güncelledi.'
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }